module.exports = __webpack_public_path__ + "img/badges.6aef334a.svg";